"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = void 0;
var DEFAULT_FONT_FAMILY = "'Overpass',sans-serif";
var fonts = {
  defaultFontFamily: DEFAULT_FONT_FAMILY,
  fontSystem: {
    display: {
      fontFamily: DEFAULT_FONT_FAMILY,
      default: {
        fontType: '700',
        fontWeight: 700
      },
      black: {
        fontType: '900',
        fontWeight: 900
      }
    },
    regular: {
      fontFamily: DEFAULT_FONT_FAMILY,
      default: {
        fontType: '400',
        fontWeight: 400
      },
      light: {
        fontType: '300',
        fontWeight: 300
      },
      lightItalic: {
        fontType: '300i',
        fontWeight: 300
      },
      bold: {
        fontType: '700',
        fontWeight: 700
      },
      boldItalic: {
        fontType: '700i',
        fontWeight: 700
      }
    },
    emphasis: {
      fontFamily: DEFAULT_FONT_FAMILY,
      default: {
        fontType: '400',
        fontWeight: 400
      },
      light: {
        fontType: '300',
        fontWeight: 300
      },
      lightItalic: {
        fontType: '300i',
        fontWeight: 300
      }
    }
  }
};
exports.fonts = fonts;